export default __webpack_public_path__ + "static/media/hwcontacts_transparent.114a1f81.svg";